import { Icon } from "@washingtonpost/wpds-icon";
import { Button } from "@washingtonpost/wpds-button";
import { styled, theme, keyframes } from "@washingtonpost/wpds-theme";

const infiniteRotation = keyframes({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(359deg)"
  }
});

export const PromoButtonWrapper = styled(Button, {
  boxSizing: "border-box",
  "&[data-state='loading']": {
    [`& ${Icon}`]: {
      animation: `${infiniteRotation} 2s linear infinite`,

      "@reducedMotion": {
        animation: "none"
      }
    },
    "&:focus": {
      outline: "1px auto -webkit-focus-ring-color"
    }
  },

  "&[data-state='buffer']": {
    borderWidth: "1px !important",

    [`& ${Icon}`]: {
      color: "white",
      transition: "none",

      animation: `${infiniteRotation} 2s linear infinite`,

      "@reducedMotion": {
        animation: "none"
      }
    }
  },
  "&[data-state-live='true']": {
    borderColor: "red !important",

    [`& ${Icon}`]: {
      color: "white"
    }
  },
  "&[data-state-live-preview='true']": {
    [`& ${Icon}`]: {
      color: "#111 !important"
    }
  }
});

export const PromoWrapper = styled("div", {
  overflow: "hidden",
  zIndex: 1,
  width: "100%",
  height: "100%",
  position: "absolute",
  top: 0,
  left: 0,
  textAlign: "left",
  variants: {
    hidden: {
      true: {
        display: "none"
      },
      false: {
        display: "block"
      }
    }
  }
});

export const PromoVideo = styled("video", {
  width: "100%",
  height: "100%"
});

export const PromoContainer = styled("div", {
  display: "flex",
  alignItems: "center",
  position: "absolute",
  bottom: "0",
  left: "0",
  padding: "16px",
  paddingTop: "48px",
  boxSizing: "border-box",
  width: "100%",
  cursor: "pointer",
  background: `linear-gradient(
    to top,
    rgba(0, 0, 0, 0.5) 0,
    rgba(0, 0, 0, 0) 100%
  )`
});

export const TextContainer = styled("div", {
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  width: "100%",
  variants: {
    small: {
      true: {
        marginLeft: "8px"
      },
      false: {
        marginLeft: "16px"
      }
    }
  }
});

export const PromoTitle = styled("div", {
  color: theme.colors["gray700-static"],
  fontFamily: "$meta",
  fontWeight: 700,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  marginRight: "8px"
});

export const PromoDuration = styled("div", {
  fontFamily: "$meta",
  color: theme.colors["gray700-static"],
  variants: {
    hidden: {
      true: {
        visibility: "hidden"
      }
    }
  }
});

export const LiveDot = styled("div", {
  height: "8px",
  width: "8px",
  marginRight: "4px",
  borderRadius: "50%",
  backgroundColor: "red",
  animation: "sc-status-light-blink-animation 2s ease-in-out infinite alternate"
});

export const LiveDotWrapper = styled("div", {
  display: "flex",
  alignItems: "center"
});
